import { Col, Row } from "antd";
import dummyImg from "../../../assets/imageplace.jpg";
import styles from "./Countdown.module.css";
import { SubmitButton, TextComponent } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from "../../../components/modal/Modal";
import CopyLinkModal from "../../../components/copyLinkModal/CopyLinkModal";
import { EditIcon } from "../../../components/icons/Icons";
import countdownLine from "../../../assets/countdownLine.svg";
import ringImg from "../../../assets/ring.png";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import moment from "moment";

const shareIcon = (
  <svg
    className={styles.btnSvg}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0392 15.6811C19.8387 15.6811 18.7588 16.1655 17.9921 16.9386L9.03356 12.7319C9.06437 12.5342 9.08559 12.3342 9.08559 12.1283C9.08559 11.9277 9.06538 11.732 9.03609 11.5397L17.9815 7.37896C18.7487 8.1584 19.8336 8.64767 21.0392 8.64767C23.3636 8.64767 25.2481 6.84028 25.2481 4.61095C25.2481 2.38113 23.3636 0.574219 21.0392 0.574219C18.7149 0.574219 16.8304 2.38113 16.8304 4.61095C16.8304 4.8115 16.8506 5.00672 16.8799 5.19952L7.93452 9.36026C7.1673 8.58082 6.0829 8.09155 4.87678 8.09155C2.55191 8.09155 0.667969 9.89895 0.667969 12.1283C0.667969 14.3581 2.55191 16.165 4.87678 16.165C6.07735 16.165 7.1572 15.6806 7.92391 14.9074L16.8825 19.1142C16.8517 19.3114 16.8304 19.5119 16.8304 19.7178C16.8304 21.9476 18.7149 23.7545 21.0392 23.7545C23.3636 23.7545 25.2481 21.9476 25.2481 19.7178C25.2481 17.488 23.3636 15.6811 21.0392 15.6811Z"
      fill="var(--primary-color)"
    />
  </svg>
);

const editIcon = (
  <svg
    className={styles.btnSvg}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_58_4525)">
      <path
        d="M25.0467 11.5412C24.7016 11.5412 24.3706 11.6814 24.1265 11.931C23.8825 12.1806 23.7454 12.5191 23.7454 12.872V20.7907C23.7433 21.496 23.4685 22.1718 22.9808 22.6705C22.4932 23.1692 21.8324 23.4503 21.1428 23.4524H10.7325C10.0429 23.4503 9.38211 23.1692 8.89447 22.6705C8.40684 22.1718 8.13198 21.496 8.12992 20.7907V10.1438C8.13198 9.43848 8.40684 8.76268 8.89447 8.26397C9.38211 7.76525 10.0429 7.48415 10.7325 7.48204H18.4752C18.8203 7.48204 19.1513 7.34182 19.3953 7.09224C19.6394 6.84265 19.7765 6.50414 19.7765 6.15118C19.7765 5.79821 19.6394 5.4597 19.3953 5.21011C19.1513 4.96053 18.8203 4.82031 18.4752 4.82031H10.7325C9.35327 4.82453 8.03171 5.38674 7.05645 6.38417C6.08118 7.3816 5.53146 8.7332 5.52734 10.1438V20.7907C5.53146 22.2012 6.08118 23.5528 7.05645 24.5503C8.03171 25.5477 9.35327 26.1099 10.7325 26.1141H21.1428C22.522 26.1099 23.8436 25.5477 24.8189 24.5503C25.7941 23.5528 26.3439 22.2012 26.348 20.7907V12.872C26.348 12.5191 26.2109 12.1806 25.9668 11.931C25.7228 11.6814 25.3918 11.5412 25.0467 11.5412ZM15.0268 16.7315C15.1443 16.8576 15.2856 16.958 15.4422 17.0266C15.5988 17.0952 15.7673 17.1306 15.9377 17.1306C16.108 17.1306 16.2766 17.0952 16.4331 17.0266C16.5897 16.958 16.731 16.8576 16.8486 16.7315L24.331 9.07908C24.5685 8.83115 24.7008 8.49736 24.6991 8.15023C24.6974 7.8031 24.5618 7.47069 24.3218 7.22523C24.0818 6.97977 23.7568 6.8411 23.4174 6.83934C23.078 6.83759 22.7516 6.9729 22.5092 7.21587L15.0268 14.8683C14.9035 14.9885 14.8053 15.1331 14.7382 15.2932C14.6711 15.4533 14.6366 15.6257 14.6366 15.7999C14.6366 15.9741 14.6711 16.1465 14.7382 16.3067C14.8053 16.4668 14.9035 16.6114 15.0268 16.7315Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_58_4525">
        <rect
          width="25"
          height="25"
          fill="white"
          transform="translate(0.824219 0.623047)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Countdown = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  // const countDownData = state?.eventData;

  const countDownData = useSelector((state) => state.EventReducer.EventDetails);
  // const clientDashBoardData = useSelector(
  //   (state) => state.DashboardReducer?.clientDashboardData
  // );
  // const countDownData = useSelector(
  //   (state) => state.DashboardReducer?.clientDashboardData
  // );
  console.log("screenData", countDownData);

  // const startDate = moment(countDownData?.count_down?.datetime);
  const [timeElapsed, setTimeElapsed] = useState({
    months: "00",
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  console.log("timeElpassss", timeElapsed);
  let timerRef = null;
  function calculateTimeElapsed(data) {
    timerRef = setInterval(() => {
      var dur = moment.duration(
        moment(data?.count_down?.datetime).diff(moment())
      );
      let yearsRemain = dur.years();
      let months = dur.months();
      let days = dur.days();
      let hours = dur.hours();
      let minutes = dur.minutes();
      let seconds = dur.seconds();
      const timeObj = {
        months:
          months < 10 && yearsRemain == 0
            ? "0" + months
            : months + 12 * yearsRemain,
        days: days < 10 ? "0" + days : days,
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds,
      };
      if (hours <= 0 && days <= 0 && months <= 0) {
        setTimeElapsed({
          months: "00",
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(timerRef);
      } else {
        setTimeElapsed(timeObj);
      }
    }, 1000);
  }
  const timeLeft = [
    {
      title: "Mon",
      duration: countDownData?.is_count_down
        ? countDownData?.is_count_down
          ? timeElapsed?.months
          : "00"
        : "00",
    },
    {
      title: "Days",
      duration: countDownData?.is_count_down
        ? countDownData?.is_count_down
          ? timeElapsed?.days
          : "00"
        : "00",
    },
    {
      title: "Hrs",
      duration: countDownData?.is_count_down
        ? countDownData?.is_count_down
          ? timeElapsed?.hours
          : "00"
        : "00",
    },
  ];
  useEffect(() => {
    dispatch(
      EventMiddleware.getEventDetails({ id: state?.eventData?.id })
    ).then((data) => {
      // setTimeout(() => {
      calculateTimeElapsed(data);
      // }, 3000);
    });
    return () => clearInterval(timerRef);
  }, []);
  return (
    <Row className={styles.mainRow}>
      <Col xs={24} lg={8} className={styles.imgCol}>
        <div className={styles.imgDiv}>
          <div className={styles.doubleImg}>
            <img
              className={styles.mainImg}
              src={
                countDownData?.is_count_down
                  ? countDownData?.image
                    ? countDownData?.image
                    : dummyImg
                  : dummyImg
              }
            />
            <img
              className={styles.backImg}
              src={
                countDownData?.is_count_down
                  ? countDownData?.image
                    ? countDownData?.image
                    : dummyImg
                  : dummyImg
              }
            />
            <img className={styles.ringImg} src={ringImg} />
          </div>
        </div>
        <TextComponent textClass={styles.imgTitle}>
          {countDownData?.is_count_down
            ? countDownData?.count_down?.bride &&
              countDownData?.count_down?.groom
              ? countDownData?.count_down?.bride +
                " & " +
                countDownData?.count_down?.groom
              : "--"
            : "Bride & Groom"}
        </TextComponent>
        {countDownData?.is_count_down && (
          <TextComponent textClass={styles.imgDesc}>
            {countDownData?.name ? countDownData?.name : "--"}
          </TextComponent>
        )}
      </Col>
      <Col xs={24} lg={16} className={styles.rightCol}>
        <Row className={styles.rightColTitleRow}>
          <TextComponent textClass={styles.rightColTitle}>
            {countDownData?.is_count_down
              ? countDownData?.category?.name
                ? countDownData?.category?.name
                : "--"
              : "Count Down"}
          </TextComponent>
        </Row>
        <Row className={styles.timeBoxes}>
          {timeLeft.map((time) => (
            <Row className={styles.timeBox}>
              <TextComponent textClass={styles.timeTitle}>
                {time.title}
              </TextComponent>
              <TextComponent textClass={styles.timeDuration}>
                {time.duration}
              </TextComponent>
            </Row>
          ))}
          <div className={styles.backLayout}></div>
          {/* <img src={countdownLine}/> */}
          <svg
            className={styles.countdownLine}
            viewBox="0 0 240 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.5859 0.607422H11.6367C5.56159 0.607422 0.636719 5.53229 0.636719 11.6074V29.9509C0.636719 36.026 5.56158 40.9509 11.6367 40.9509H68.5859V38.9509H11.6367C6.66615 38.9509 2.63672 34.9215 2.63672 29.9509V11.6074C2.63672 6.63686 6.66616 2.60742 11.6367 2.60742H68.5859V0.607422ZM171.539 38.9509H228.637C233.607 38.9509 237.637 34.9215 237.637 29.9509V11.6074C237.637 6.63686 233.607 2.60742 228.637 2.60742H171.539V0.607422H228.637C234.712 0.607422 239.637 5.53229 239.637 11.6074V29.9509C239.637 36.0261 234.712 40.9509 228.637 40.9509H171.539V38.9509Z"
              fill="var(--primary-color)"
            />
          </svg>
        </Row>
        <Row className={styles.date}>
          <TextComponent>
            {countDownData?.is_count_down
              ? countDownData?.count_down?.datetime
                ? moment(countDownData?.count_down?.datetime).format(
                    "MMM DD YYYY"
                  )
                : "MM DD, YYYY"
              : "MM DD, YYYY"}
          </TextComponent>
        </Row>
        <Row className={styles.btnRow}>
          <div
            className={styles.iconBtnOutline}
            onClick={() => setModalOpen(true)}
          >
            {shareIcon}
          </div>
          <div
            className={styles.iconBtn}
            onClick={() =>
              navigate("/events/eventDetail/editCountdown", {
                state: { headrTitle: "Edit Countdown", data: countDownData },
              })
            }
          >
            {editIcon}
            {/* <EditIcon size={20}/> */}
          </div>
        </Row>
      </Col>
      <CopyLinkModal
        isCopyModalOpen={modalOpen}
        setIsCopyModalOpen={setModalOpen}
        link="https://bestdayever-web.web.app"
      />
    </Row>
  );
};

export default Countdown;
